export default __webpack_public_path__ + "static/media/planticon_4.2ef1e478.png";